const OpposingArrowsOffset = () => (
  <>
    <path
      fill="currentColor"
      d="M10.387 15.173H3.5a.48.48 0 0 1-.357-.143.48.48 0 0 1-.143-.357q0-.213.143-.357a.48.48 0 0 1 .357-.143h6.887l-2.74-2.74a.5.5 0 0 1-.15-.342.48.48 0 0 1 .15-.366q.165-.165.356-.165t.357.165l3.382 3.383a.8.8 0 0 1 .184.267.8.8 0 0 1 .053.298.8.8 0 0 1-.053.298.8.8 0 0 1-.184.268l-3.388 3.388a.48.48 0 0 1-.707-.006.52.52 0 0 1-.163-.354.48.48 0 0 1 .162-.354zm3.226-5.365 2.74 2.74a.5.5 0 0 1 .15.341.48.48 0 0 1-.15.367.5.5 0 0 1-.356.165.5.5 0 0 1-.357-.165l-3.382-3.383a.8.8 0 0 1-.184-.267.8.8 0 0 1-.053-.298q0-.162.053-.298a.8.8 0 0 1 .184-.268l3.388-3.388a.48.48 0 0 1 .708.006q.159.165.162.354a.48.48 0 0 1-.162.353l-2.74 2.74H20.5q.213 0 .357.144a.48.48 0 0 1 .143.357.48.48 0 0 1-.143.357.48.48 0 0 1-.357.143z"
    />
  </>
)
export default OpposingArrowsOffset
